<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">Situation locative</p>
		</div>

		<el-title :index="1">
			Analyse du marché locatif de la commune
		</el-title>

		<div class="tle-row q-mb-md">
			<div class="tle-col three-quarter">
				<el-yanport-params
					save_parent="page_4"
				/>
				<error v-if="!active_study.etudeData.yanportData4" :show-in-read-mode="true" />
				<div  v-else>
					<el-table :table="table_marche_locatif" class="table-marche-locatif"/>
					<p>Source : Données statistiques Yanport</p>
				</div>
				
			</div>
			<div class="tle-col one-quarter">
				<error v-if="!active_study.etudeData.yanportData4" :show-in-read-mode="true" />
				<template v-else>
					<el-square
					:parent_data="
						active_study.etudeData.yanportData4.kpiLocatif.biensPublies
					"
					property="count"
					label="Stock"
					format="number"
					suffix=""
					:sub_value="{value: 'Nombre de référence depuis 1 an'}"
					class="q-mb-sm"
					/>
					<el-square
					:parent_data="
						active_study.etudeData.yanportData4.kpiLocatif.prixm2.values
					"
					property="50.0"
					label="Prix"
					format="number"
					suffix="€/m² HC"
					:sub_value="{value: 'Loyer HC médian au m² depuis 1 an'}"
					class="q-mb-sm"
					/>
					<el-square
					:parent_data="
						active_study.etudeData.yanportData4.kpiLocatif.dureePublication.values
					"
					property="50.0"
					label="Durée"
					format="number"
					suffix="jours"
					:sub_value="{value: 'Durée médiane de publication depuis 1 an'}"
					/>
				</template>
			</div>
		</div>

		<div class="q-mt-md">
			<div class="comment">
				<el-textarea
					class="detail-site"
					:parent_data="active_study.etudeData.scpi.situation_locative"
					property="commentaire_locatif"
					:editable="true"
					placeholder="Commentaire"
					:height="'90px'"
					overflow_edit='hidden scroll'
					text_align="justify"
				/>
			</div>
		</div>
		
		<el-title :index="2">
			Analyse de la situation actuelle par rapport au marché
		</el-title>

		<div class="q-mb-md">
			<el-table :table="table_analyse_actuelle" />
			<p v-if="table_overflow">Ce tableau n'intègre qu'un échantillon. Retrouvez l'intégralité des {{ this.active_study.etudeData.kyaneosData.Lots.length }} lots en annexe</p>
		</div>

		<div class="comment">
			<el-textarea
				class="detail-site"
				:parent_data="active_study.etudeData.scpi.situation_locative"
				property="commentaire_situation_actuelle"
				:editable="true"
				placeholder="Commentaire"
				:height="'90px'"
				overflow_edit='hidden scroll'
				text_align="justify"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";
import ElYanportParams from "@/components/study/editor/elements/el-yanport-params.vue";

export default {
	components: { KyaneosHeader, ElYanportParams },
	name: "page-kyaneos-4",
	mixins: [ PageMixin ],
	props: [ "index" ],
	data: function () {
		return {
			max_row_table: 9
		};
	},
	computed: {
		...mapGetters([ "active_project", "active_study", "editor" ]),
		table_marche_locatif: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [25, 25, 25, 25],
				},
			};

			table.head.push(["Type (surface)", "Prix/m² HC", "Durée de publication", "Nombre de références"]);

			const rows = [];

			try {
				Object.entries(this.active_study.etudeData.yanportData4.tableauLocatif).forEach(([roomCount, data]) => {
					const isGlobal = roomCount == "undefined";
					const surfaceMediane = Math.floor( isNaN(data.surfaceMediane.values["50.0"]) ? 0 : data.surfaceMediane.values["50.0"] || 0 );
					const prixm2 = ( isNaN(data.prixm2.values["50.0"]) ? 0 : data.prixm2.values["50.0"] || 0 ).toFixed(2);
					const dureePublication = Math.round( isNaN(data.dureePublication.values["50.0"]) ? 0 : data.dureePublication.values["50.0"] || 0);
					rows.push([
						{
							value: `${!isGlobal ? `${roomCount}P` : "GLOBAL"} ${surfaceMediane}m²`,
							text_align: "center",
							bg_color: isGlobal ? "gray" : undefined
						},
						{
							value: prixm2,
							suffix: "€/m² HC",
							bg_color: isGlobal ? "gray" : undefined
						},
						{
							value: dureePublication,
							suffix: "jours",
							bg_color: isGlobal ? "gray" : undefined
						},
						{
							value: data.surfaceMediane.count,
							suffix: "biens",
							text_align: "center",
							bg_color: isGlobal ? "gray" : undefined
						},
					]);
				});
			} catch(e) {
				console.error("Error in getting Yanport data", e);
			}

			table.body = rows;

			return table;
		},
		table_analyse_actuelle: function () {
			const table = {
				head: [],
				body: [],
				config: {
					// cols_width: [25, 25, 25, 25],
				},
			};

			table.head.push(["Code", "Type", "Surf. hab.", "Type Bail", "Loyer", "Etat locatif", "Ratio locatif"]);

			const lots = this.active_study.etudeData.kyaneosData.Lots;
			const indexMax = this.table_overflow ? this.max_row_table - 1 : this.max_row_table;
			lots.forEach((lot, index) => {
				const loc = lots[index];

				const ratio = (loc.Loyer / loc.Surface).toFixed(2);
				if(index < indexMax){
					table.body.push([
						{
							parent_data: loc,
							property: "Code",
							editable: true,
						},
						{
							parent_data: loc.TypeLogement,
							property: "Libelle",
							editable: true,
						},
						{
							parent_data: loc,
							property: "Surface",
							editable: true,
						},
						{
							parent_data: loc,
							property: "TypeBail",
							editable: true,
						},
						{
							parent_data: loc,
							property: "Loyer",
							editable: true,
							suffix: "€"
						},
						{
							parent_data: loc,
							property: "EtatLocatif",
							editable: true
						},
						{
							value: isNaN(ratio) ? "-" : ratio,
							suffix: "€/m²"
						}
					]);
				}
			});
			if(this.table_overflow){
				table.body.push([
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					}
				]);
			}
			return table;
		},
		table_overflow: function () {
			return this.active_study.etudeData.kyaneosData.Lots.length > this.max_row_table;
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'

.table-marche-locatif
	>>> .el-row__content
		font-size 12px
		line-height 1.3
</style>